/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxGalleryActionComponent as ɵb} from './lib/ngx-gallery-action/ngx-gallery-action.component';
export {NgxGalleryImageComponent as ɵa} from './lib/ngx-gallery-image/ngx-gallery-image.component';